import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional class-name helper used by every shadcn/ui-style component.
 *
 *   cn('p-4', condition && 'bg-blue-500', { 'opacity-50': disabled })
 *
 * Combines `clsx` (conditional class joining) with `tailwind-merge` (resolves
 * conflicting Tailwind utility classes — e.g., the last `px-4` wins over `px-2`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
